import React from 'react';
import PropTypes from 'prop-types';

import { getScoreboardHeaders } from 'InPlayOverview/services/scoreboard_factory';

const CouponHeader = ({
  couponName,
  sport,
  treeType,
  firstScoreboard,
  headers,
  competition,
}) => {
  const scoreboardHeaders = getScoreboardHeaders(
    couponName, sport, treeType, firstScoreboard,
  );
  return (
    <div className="inply-coupon-row inply-competition-header-row">
      <div className="inply-coupon-favcompetition-column">
        <span className="inply-coupon-favstar-icon" />
        <span className="inply-coupon-competition-label">{competition.desc}</span>
      </div>
      { couponName !== 'template_c'
        && (
        <div className="inply-coupon-score-column">
          { scoreboardHeaders
            && (
            <div className={`inply-coupon-score-row ${scoreboardHeaders.className}`}>
              {scoreboardHeaders.labels.map((h) => <span key={h} className="inply-coupon-score-label">{h}</span>)}
            </div>
            )}
        </div>
        )}
      {couponName !== 'template_c'
        && (
        <div className="inply-coupon-odds-column">
          {(headers || []).map((h, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={`${h}-${i}`} className="inply-coupon-odds-label">{h}</span>
          ))}
        </div>
        )}
    </div>
  );
};

CouponHeader.propTypes = {
  competition: PropTypes.instanceOf(Object).isRequired,
  headers: PropTypes.instanceOf(Array).isRequired,
  couponName: PropTypes.string.isRequired,
  sport: PropTypes.instanceOf(Object).isRequired,
  treeType: PropTypes.string.isRequired,
  firstScoreboard: PropTypes.instanceOf(Object).isRequired,
};

export default CouponHeader;
